import { Button } from "@material-ui/core"
import { Links, ShopLinks } from "common/SiteLinks"
import useDebounce from "common/bit/hooks/useDebounce"
import { useScrollDirection } from "common/bit/hooks/useScrollDirection"
import { useRouter } from "next/router"
import { FC, useEffect, useRef, useState } from "react"
import styled from "styled-components"
import Footer from "./footer/Footer"
import Header from "./header/Header"
export { HEADER_HEIGHT_D, HEADER_HEIGHT_M } from "theme/shared"

const StyledMain = styled.main`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  flex-grow: 1;

  :focus {
    outline: 0;
  }
`

const StyledButton = styled(Button)`
  position: fixed;
  z-index: -10;
  background-color: black;
  color: white;
  top: 0;
  &:focus-visible {
    z-index: 9999999;
  }
`

const Layout: FC<any> = ({ children }) => {
  const mainRef = useRef<HTMLDivElement>(null)
  const { pathname } = useRouter()
  const [narrowHeader, setNarrowHeader] = useState(false)

  const scrollDirection = useScrollDirection()
  const debouncedScrollDirection = useDebounce(scrollDirection, 100)

  useEffect(() => {
    if (debouncedScrollDirection === "down") {
      setNarrowHeader(true)
    } else {
      setNarrowHeader(false)
    }
  }, [debouncedScrollDirection])

  const getHeader = (pathname: string) => {
    if (
      pathname.indexOf("/shop") > -1 &&
      pathname !== Links.OnlinePurchase.link
    )
      return (
        <Header
          narrow={true}
          links={ShopLinks}
          hamburgerLink="/shop"
          isShopHeader={true}
        />
      )

    if (
      pathname !== "/model/[modelId]/[modelSlug]" &&
      pathname !== "/about-us" &&
      pathname !== "/showroomsscreens/[model]" &&
      pathname !== "/landing/[modelSlug]"
    )
      return <Header narrow={narrowHeader} />

    return false
  }

  const handleClick = () => {
    if (mainRef.current) {
      mainRef.current.focus()
    }
  }

  return (
    <>
      <StyledButton id="skip-to-content" onClick={handleClick} tabIndex={2}>
        דלג לתוכן המרכזי
      </StyledButton>
      {getHeader(pathname)}

      <StyledMain id="mainContent" tabIndex={-1} ref={mainRef}>
        {children}
      </StyledMain>
      {pathname !== "/shop/[model]" &&
        pathname !== "/shop/success" &&
        pathname !== "/showroomsscreens/[model]" &&
        pathname !== "/landing/[modelSlug]" && <Footer />}
    </>
  )
}

export default Layout
